<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M2.667 13.333c-.367 0-.681-.13-.942-.391A1.284 1.284 0 0 1 1.333 12V4c0-.367.13-.68.392-.942.261-.26.575-.391.942-.391h10.666c.367 0 .68.13.942.391.261.261.392.575.392.942v8c0 .367-.131.68-.392.942a1.284 1.284 0 0 1-.942.391H2.667Zm0-1.333h2.666V4H2.667v8Zm4 0h2.666V4H6.667v8Zm4 0h2.666V4h-2.666v8Z"
        />
    </svg>
</template>

<script setup lang="ts">
type PhasesIconProps = {
    ariaLabelledby?: string;
};
const props = defineProps<PhasesIconProps>();
</script>
